import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import axiosInstance from '../../services/axiosInstance'
import PageHeader from '../../components/common/PageHeader'
import { Search, Plus, FileText, ChevronRight } from 'lucide-react'
import './styles.scss'

export default function StudentApplications() {
  const navigate = useNavigate()
  const [applications, setApplications] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetchApplications()
  }, [])

  const fetchApplications = async () => {
    try {
      const res = await axiosInstance.get('/api/applications/me/all')
      setApplications(res.data?.data || [])
    } catch (e) {
      console.error('Failed to load applications', e)
    } finally {
      setLoading(false)
    }
  }

  const getStatusBadge = (status) => {
    switch (status) {
      case 'APPLICATION_STARTED': return <span className="badge badge-draft">Draft</span>
      case 'SUBMITTED': return <span className="badge badge-submitted">Submitted</span>
      case 'UNDER_REVIEW': return <span className="badge badge-review">Under Review</span>
      case 'ADMITTED': return <span className="badge badge-admitted">Admitted</span>
      case 'REJECTED': return <span className="badge badge-rejected">Rejected</span>
      default: return <span className="badge badge-draft">{status?.replace('_', ' ')}</span>
    }
  }

  return (
    <div className="page-container student-applications">
      <PageHeader 
        title="My Applications" 
        subtitle="Track the status of your university applications."
        action={
          <button className="btn btn-primary" onClick={() => navigate('/discover')}>
            <Plus size={16} /> Start New Application
          </button>
        }
      />

      {loading ? (
        <div style={{ display: 'flex', justifyContent: 'center', padding: '3rem' }}>
          <div className="spinner" style={{ width: '40px', height: '40px', border: '3px solid rgba(37,99,235,0.2)', borderTopColor: '#2563EB', borderRadius: '50%', animation: 'spin 1s linear infinite' }} />
        </div>
      ) : applications.length === 0 ? (
        <div className="empty-state">
          <FileText size={48} className="empty-icon" />
          <h3>No Applications Yet</h3>
          <p>You haven't started any university applications. Browse our partner universities to find your fit.</p>
          <button className="btn btn-primary" onClick={() => navigate('/discover')}>
            Discover Universities
          </button>
        </div>
      ) : (
        <div className="applications-list">
          {applications.map(app => (
            <div className="app-card" key={app.id || app.application?.id} onClick={() => navigate('/dashboard')}>
              <div className="app-card__header">
                <div className="univ-info">
                  <h3>{app.universityName || 'University'}</h3>
                  <p>{app.programName} • {app.intakeName}</p>
                </div>
                {getStatusBadge(app.application?.status)}
              </div>
              <div className="app-card__body">
                <div className="app-meta">
                  <span className="label">Application ID:</span>
                  <span className="value">{app.application?.applicationNumber || 'Pending'}</span>
                </div>
                <div className="app-meta">
                  <span className="label">Last Updated:</span>
                  <span className="value">
                    {app.application?.updatedAt 
                      ? new Date(app.application.updatedAt).toLocaleDateString() 
                      : app.application?.createdAt 
                        ? new Date(app.application.createdAt).toLocaleDateString() 
                        : 'N/A'}
                  </span>
                </div>
                <div className="app-action">
                  <span>View Details</span>
                  <ChevronRight size={16} />
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
